import React from "react";
import Chart from "react-apexcharts";
import { COLORES_CATEGORIA } from "./constants";
import { formatNumber, truncarNombre } from "./utils";

export default function GraficoCategoriaInventario(props) {
    const datos = props.datos || [];
    const total = props.total || 0;
    const labels = datos.map((item) => item.nombre);
    const series = datos.map((item) => item.cantidad);

    const options = {
        chart: { type: "donut" },
        labels,
        colors: COLORES_CATEGORIA,
        dataLabels: { enabled: false },
        stroke: { width: 2 },
        legend: {
            position: "right",
            verticalAlign: "middle",
            fontSize: "12px",
            itemMargin: { vertical: 5 },
            formatter: (nombre, opts) => {
                const item = datos[opts.seriesIndex] || { cantidad: 0, porcentaje: 0 };
                // ApexCharts inserta este resultado como innerHTML, por eso
                // el <br/> corta la linea antes de la cantidad.
                return `${truncarNombre(nombre)}<br/><span style="color:#64748b">${item.cantidad} (${formatNumber(item.porcentaje)}%)</span>`;
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "62%",
                    labels: {
                        show: true,
                        value: { fontSize: "20px", fontWeight: 700 },
                        total: {
                            show: true,
                            label: "Total",
                            fontSize: "13px",
                            formatter: () => `${total}`,
                        },
                    },
                },
            },
        },
        // Los tooltips de dona no usan tooltip.x/tooltip.y.title (esos son
        // para charts de ejes); para truncar el nombre hay que armarlo a mano.
        tooltip: {
            custom: ({ seriesIndex, w }) => {
                const nombre = truncarNombre(w.config.labels[seriesIndex]);
                const item = datos[seriesIndex] || { cantidad: 0, porcentaje: 0 };
                const color = w.config.colors[seriesIndex % w.config.colors.length];
                return `
                    <div style="padding:8px 12px;">
                        <span style="color:${color};margin-right:6px;">●</span>
                        <strong>${nombre}</strong>: ${item.cantidad} (${formatNumber(item.porcentaje)}%)
                    </div>
                `;
            },
        },
        // En pantallas angostas la leyenda a la derecha aprieta la dona; ahi
        // se pasa a leyenda inferior en vez de forzar scroll horizontal.
        responsive: [
            {
                breakpoint: 576,
                options: {
                    legend: {
                        position: "bottom",
                        itemMargin: { horizontal: 8, vertical: 4 },
                    },
                },
            },
        ],
    };

    // react-apexcharts compara las options con JSON.stringify, que ignora las
    // funciones: si solo cambian las cantidades (formatters de leyenda y
    // total), no re-renderiza. La key obliga a remontar la dona.
    const claveDatos = datos.map((item) => `${item.nombre}:${item.cantidad}`).join("|");

    return (
        <Chart
            key={claveDatos}
            options={options}
            series={series}
            type="donut"
            width="100%"
            height={300}
        />
    );
}
